// bookingsApi.js
/* (RTK Query service) */

import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { URLAPI } from "../../configuration";

// original baseQuery
const rawBaseQuery = fetchBaseQuery({
    baseUrl: URLAPI,
    prepareHeaders: (h, { getState }) => {
        const token = getState().auth.user.jwt;
        if (token) h.set("Authorization", `Bearer ${token}`);
        return h;
    },
});

// new baseQuery with automatic retries
const baseQuery = retry(rawBaseQuery, {
    maxRetries: 20, // ⇒ 1 first try + 20 re-tries
    // retryCondition: (error) => error?.status >= 500, // optional
});

export const bookingsApi = createApi({
    reducerPath: "bookingsApi",
    baseQuery,
    tagTypes: ["Reservations"],
    endpoints: (builder) => ({
        getBookings: builder.query({
            /*  arg === { hotelID, body }  */
            query: ({ hotelID, body }) => ({
                url: `/reservations/${hotelID}`,
                method: "POST",
                body,
            }),
            providesTags: ["Reservations"],
            keepUnusedDataFor: 60 * 30,
            transformResponse: (response) => {
                const { cache_ttl, ...rest } = response ?? {};
                return { ...rest, cache_ttl: cache_ttl ?? null };
            },
        }),
    }),
});

export const { useGetBookingsQuery } = bookingsApi;
